import React from 'react'
import SkeletonTable from '../../components/skeletons/SkeletonTable';
import ErrorSection from '../../components/global/ErrorSection';
import Table from '../../components/custom/tableWrapper/Table';
import { coulmnsType, DictionaryType, tableConfig } from '../../types';
import { useGetAllCustomerMembershipsQuery, useGetAllMembershipsQuery } from '../../lib/redux/services/sections/Customers';
import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { UserSliceType } from '../../lib/redux/slices/userSlice';
import { cn } from '../../utils/utils';
import { useGetDictionary } from '../../hooks/useGetDictionary';

type Props = {}

function CustomerMemberships({}: Props) {
  const { inputs, customers }: DictionaryType = useGetDictionary();
  const membershipColumns: coulmnsType = [
    {
      title: inputs.name,
      tag: "name",
    },

    {
      title: inputs.start,
      tag: "start_date",
    },
    {
      title: inputs.end,
      tag: "end_date",
    },
    {
      title: inputs.status,
      tag: "status",
    },
  ];
  
  const clubId = useSelector((state: UserSliceType) => state.user.selectedClub);
  const param = useParams();
  const {
    data: membershipData,
    isLoading: isLoadingMembership,
    isError: isErrorMembership,
    error: errorMembership,
    refetch: refetchMembership,
    isFetching: isFetchingMembership,
  } = useGetAllCustomerMembershipsQuery({
    clubId,
    player_id: param.id,
    membership_status: '',
  });
  const config: tableConfig = {
    status: {
      isCustomViewChildren: true,
      customViewChildren: (row, tag) => {
        return (
          <td className="flex-1 p-4 min-w-[150px] text-center">
            <div
              className={cn(
                "grid place-content-center px-4 py-2 rounded-3xl w-[100px] mx-auto ml-0",
                row[tag] === "active"
                  ? "bg-[#34C759] text-primary dark:text-white"
                  : "text-[#F3F3F3] bg-[#EF4626]"
              )}
            >
             {row[tag]?.substring(0,1).toUpperCase() + row[tag]?.substring(1)}
            </div>
          </td>
        );
      },
    },
  };
  const renderTable = () => {
    if (isLoadingMembership || isFetchingMembership) {
      return <SkeletonTable />;
    }
    if (isErrorMembership) {
      return <ErrorSection />;
    }
    return (
      <div className=" fixed-table customer-table">
        <Table
          columnsData={membershipColumns}
          rowData={membershipData?.data}
          config={config}
          generalCellColumnClassName="  "
          generalCellRowClassName="  min-w-[150px] w- overflow-hidden text-left "
          generalRowClassName=" text-center relative"
          generalColumnsClassName=" bg-[#F3F3F3] text-primary dark:text-white  static text-left "
        />
      </div>
    );
  };
  return (
    <div className="p-8 pt-10 relative ">
      <h2 className="pb-4 relative">
        {customers.memberships}
        
      </h2>
      {renderTable()}
    </div>
  );
}

export default CustomerMemberships